// src/components/salesChatWidget.js
import './ecommerceAgent.css';

import React from 'react';
// Make sure you import your stylesheet at the top!
// For example: import './YourStyles.css';

function ShopifyChatWidget() {
  return (
    // Use the className for the wrapper
    <div className="sales-widget-wrapper">
      {/* Use the className for the main container */}
      <div className="sales-widget-container">

        {/* --- LEFT COLUMN: Explanatory Text --- */}
        <div className="sales-widget-left-col">
          <h1 style={{ margin: '3rem 1rem 1rem 0', marginTop: '0' }}>Shopify AI Agent 👉</h1>
          <div className="form-intro">
            <p>
              This agent is a
              {' '}
              <strong>Shopify DEMO</strong>
              {' '}
              product, designed specifically for shopify stores that want to allow their users/clients/prospects to interact with their product and industry database through a more dynamic digital experience rather than the current browsing one.
              <br />
              <br />
              This shopping experience is connected to
              {' '}
              <strong>Colour Pop Makeup Shopify Store </strong>
              <a href="https://colourpop.com/" target="_blank" rel="noopener noreferrer">Visit Site</a>
              ,
              but it could be your store instead! Feel free and try the new shopping experience yourself!
            </p>

            <div>
              <div className="ai-agent-steps">
                <p>✅ Connects to databases, API`s, files and much more!.</p>
                <p>✅ User onboarding, history logs and more!</p>
              </div>
            </div>

            <p>
              <i>
                *Each agent’s logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, you’re instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to the full request history.
              </i>
            </p>

            <div>
              <strong>NOTE:</strong>
              {' '}
              If you`d like to learn more about offering this experience to your own clients or website visitors, you can book a meeting with me here:
              {' '}
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer">Calendly.</a>
              <div style={{ marginTop: '1rem' }}>
                {/* <a href="https://www.loom.com/share/bf8b4094481343349cc394f4c1db5768?sid=da4cf580-09e6-4957-9322-64c97f462676" target="_blank" rel="noopener noreferrer">Watch the quick explainer video.</a> */}
              </div>
            </div>

            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By chatting with the agent, you agree to be contacted via email with content and occasional updates related to this service.</p>
            </div>
          </div>
        </div>

        {/* --- RIGHT COLUMN: Chat Widget --- */}
        <div className="sales-widget-right-col">
          <div className="required-note" style={{ marginBottom: '0.5rem' }}>
            {' '}
          </div>
          <iframe
            key="n8n-chat-widget-iframe"
            src="/shopify.html"
            title="Shopping Chat Widget"
            style={{
              // These styles are fine to keep inline as they don't conflict
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        </div>

      </div>
    </div>
  );
}

export default ShopifyChatWidget;
